import React, { FC, useState } from 'react';
import { MARK_UNSPAM_TICKETS } from '@nile/graphql';
import { useMutation } from '@apollo/client';
import { toast, withErrorBoundary } from '@nile/components';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  TextContainer,
  Modal,
  Badge,
  TextStyle
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';

interface Ticket {
  ticketId: number;
}

interface InputVariables {
  ticket: Ticket[];
  unspamRequester: Boolean;
}

interface UnspamButtonProps {
  inputVariables: InputVariables;
  onCompleted?: () => void;
  showWarning?: Boolean;
  type?: String;
  modalActive?: Boolean;
}

const UnspamTicketsButton: FC<UnspamButtonProps> = (props) => {
  const { inputVariables, onCompleted, showWarning, type, modalActive } = props;

  const [warningModalActive, setWarningModalActive] = useState(
    modalActive || false
  );

  const toggleWarningModal = () => {
    setWarningModalActive((prevState) => !prevState);
  };

  const [
    markUnSpamTickets,
    { loading: unSpamming, error: spamError }
  ] = useMutation(MARK_UNSPAM_TICKETS, {
    onCompleted({ unspamTickets }) {
      toast('success', 'app.toast.ticket.unspam.success');
      if (onCompleted) {
        onCompleted(unspamTickets);
        if (warningModalActive) {
          setWarningModalActive(false);
        }
      }
    }
  });

  const unspamTickets = () => {
    markUnSpamTickets({
      variables: {
        input: inputVariables
      }
    });
  };

  return (
    <>
      {type === 'ActionList' ? (
        <div
          onClick={showWarning ? toggleWarningModal : unspamTickets}
          className="flex center g8 pointer actr p5 hover-bg br-5"
        >
          <div className="flex">
            <Badge
              status={'attention'}
              icon={<SVGIcon name="Unspam" size="sm" color="#323232" />}
              radial
            />
          </div>
          <div>
            <TextStyle>
              <FormattedMessage id="common.unspam" />
            </TextStyle>
          </div>
        </div>
      ) : (
        <Button
          onClick={showWarning ? toggleWarningModal : unspamTickets}
          icon={<SVGIcon name="Unspam" color="#323232" />}
          loading={unSpamming}
        >
          <FormattedMessage id="common.unspam" />
        </Button>
      )}

      <Modal
        activator={<></>}
        open={warningModalActive}
        onClose={toggleWarningModal}
        variant="confirmation"
        title={<FormattedMessage id="common.confirmation" />}
        primaryAction={{
          content: <FormattedMessage id="common.confirm" />,
          onAction: unspamTickets,
          loading: unSpamming
        }}
        iconSize="xl"
        secondaryActions={[
          {
            content: <FormattedMessage id="common.cancel" />,
            onAction: toggleWarningModal
          }
        ]}
      >
        <TextContainer>
          <FormattedMessage id="ticket.unspam.warning.message" />
        </TextContainer>
      </Modal>
    </>
  );
};

export default withErrorBoundary(UnspamTicketsButton);
